//eslint-disable
import cssVars from 'css-vars-ponyfill';

const isInternetExplorer = () => {
  const ua = window.navigator.userAgent;
  const ie = ua.indexOf('Trident/');

  // If browser is Internet Explorer
  if (ie === -1) {
    return false; 
  } else {
    return true;
  }
}

const internetExplorerBodges = () => {
  if(!isInternetExplorer()) { return }

  const link = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('type', 'text/css');
  link.setAttribute(
    'href',
    'https://fonts.googleapis.com/css?family=Lato:400,400i,700&display=swap'
  );

  document.head.appendChild(link);

  const body = document.getElementsByTagName('body')[0];
  body.classList.add('is-ie');
  
  cssVars({
  // Targets
    rootElement   : document,
    shadowDOM     : false,

    // Sources
    include       : 'link[rel=stylesheet],style',
    exclude       : '',
    variables     : {},

    // Options
    onlyLegacy    : true,
    preserveStatic: true,
    preserveVars  : false,
    silent        : false,
    updateDOM     : true,
    updateURLs    : true,
    watch         : false,

  });
};

export {internetExplorerBodges, isInternetExplorer};
